import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Card,
  CardContent,
  Box,
  CircularProgress,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import color from "../utils/Colors";
import { ShoppingCart } from "@mui/icons-material";

interface PopupProps {
  open: boolean;
  handleClose: () => void;
  data: {
    title: string;
    updatedDate: string;
    hours: string;
    level: string;
    subtitles: string;
    description: string;
    points: string[];
  };
  onAddToCart?: () => void;
  onAddToWishlist?: () => void;
  addingToCart?: boolean;
  addingToWishlist?: boolean;
}

const CardPopup = ({
  open,
  handleClose,
  data,
  onAddToCart,
  onAddToWishlist,
  addingToCart = false,
  addingToWishlist = false,
}: PopupProps) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Card
          elevation={0}
          style={{ textAlign: "center", borderRadius: "18px", width: "350px" }}
        >
          <CardContent sx={{ p: 2, pt: 1 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: color.textColor,
                borderBottom: "solid 1px",
                borderColor: "grey",
                m: -2,
                my: 2,
                pb: 1,
              }}
            >
              {data.title}
            </Typography>

            {(data.hours || data.level) && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexWrap="wrap"
                gap={0.5}
              >
                {data.hours && (
                  <Typography variant="body2" style={{ marginRight: "8px" }}>
                    {data.hours}
                  </Typography>
                )}
                {data.level && (
                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                    {data.level}
                  </Typography>
                )}
                {data.updatedDate && (
                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                    {data.updatedDate}
                  </Typography>
                )}
              </Box>
            )}

            {data.description && (
              <Typography
                variant="body1"
                style={{
                  marginTop: "16px",
                  color: color.textColor,
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                {data.description}
              </Typography>
            )}

            {data.points && data.points.length > 0 && (
              <ul
                style={{
                  textAlign: "left",
                  padding: "0 16px",
                  color: color.textColor,
                }}
              >
                {data.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            )}

            <Box
              display="flex"
              justifyContent="space-between"
              marginTop="28px"
              sx={{ gap: "10px" }}
            >
              <Button
                id="button1"
                disabled={addingToCart}
                onClick={() => {
                  if (onAddToCart) {
                    onAddToCart();
                    handleClose();
                  }
                }}
                style={{ transition: "transform 0.3s ease", minWidth: "120px" }}
              >
                {addingToCart ? (
                  <CircularProgress size={16} />
                ) : (
                  <>
                    Add to Cart
                    <ShoppingCart sx={{ ml: 1, width: "18px" }} />
                  </>
                )}
              </Button>

              <Button
                disabled={addingToWishlist}
                style={{
                  backgroundColor: color.firstColor,
                  color: "white",
                  padding: "6px",
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  borderRadius: "8px",
                  textTransform: "none",
                  transition: "transform 0.3s ease",
                  minWidth: "130px",
                }}
                onClick={() => {
                  if (onAddToWishlist) {
                    onAddToWishlist();
                    handleClose();
                  }
                }}
              >
                {addingToWishlist ? (
                  <CircularProgress size={16} sx={{ color: "white" }} />
                ) : (
                  <>
                    Add to Wishlist
                    <FavoriteBorderIcon sx={{ ml: 1, width: "18px" }} />
                  </>
                )}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default CardPopup;
